import React from 'react';

import { UserAction } from '~/eds/src/types/UserAction';

import { Actions } from '../../Actions/Actions';
import { Layout } from '../../Layout/Layout';

interface Props {
  leftActions?: UserAction[];
  rightActions?: UserAction[];
}

export const DropdownActionsFooter = ({
  leftActions = [],
  rightActions = [],
}: Props) => {
  if (leftActions.length === 0 && rightActions.length === 0) {
    return null;
  }

  const justify =
    leftActions.length > 0 && rightActions.length > 0
      ? 'space-between'
      : leftActions.length > 0
        ? 'flex-start'
        : 'flex-end';

  return (
    <Layout justify={justify} borderTop="border.divider" p={2}>
      {leftActions.length > 0 && (
        <Actions
          actions={leftActions.map((action) => ({
            ...action,
            level: action.level ?? 'tertiary', // Default to tertiary level if not specified
          }))}
        />
      )}
      {rightActions.length > 0 && (
        <Actions
          actions={rightActions.map((action) => ({
            ...action,
            level: action.level ?? 'tertiary',
          }))}
        />
      )}
    </Layout>
  );
};
